import type { AccordionItemConfig } from '@/components/Accordion';

const CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

type SafetyStep = {
  icon: string;
  titleKey: string;
  descriptionKey: string;
};

export function getIconSrc(iconName: string) {
  return `${CLOUDFRONT_HOST}/web/assets/trustPage/${iconName}.png`;
}

export const SAFETY_STEPS: SafetyStep[] = [
  {
    icon: 'SafetyPage.HowItWorks.Step1.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step1.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step1.Description',
  },
  {
    icon: 'SafetyPage.HowItWorks.Step2.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step2.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step2.Description',
  },
  {
    icon: 'SafetyPage.HowItWorks.Step3.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step3.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step3.Description',
  },
  {
    icon: 'SafetyPage.HowItWorks.Step4.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step4.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step4.Description',
  },
  {
    icon: 'SafetyPage.HowItWorks.Step5.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step5.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step5.Description',
  },
  {
    icon: 'SafetyPage.HowItWorks.Step6.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step6.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step6.Description',
  },
  {
    icon: 'SafetyPage.HowItWorks.Step7.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step7.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step7.Description',
  },
  {
    icon: 'SafetyPage.HowItWorks.Step8.Icon',
    titleKey: 'SafetyPage.HowItWorks.Step8.Title',
    descriptionKey: 'SafetyPage.HowItWorks.Step8.Description',
  },
];

export const accordionData: AccordionItemConfig[] = [
  {
    titleKey: 'SafetyPage.FAQ.BuyerProtection.Title',
    contentKey: 'SafetyPage.FAQ.BuyerProtection.Content',
  },
  {
    titleKey: 'SafetyPage.FAQ.BeforeBuying.Title',
    contentKey: 'SafetyPage.FAQ.BeforeBuying.Content',
  },
  {
    titleKey: 'SafetyPage.FAQ.DepopProtection.Title',
    contentKey: 'SafetyPage.FAQ.DepopProtection.Content',
  },
  {
    titleKey: 'SafetyPage.FAQ.ReportingScams.Title',
    contentKey: 'SafetyPage.FAQ.ReportingScams.Content',
  },
];
